export class Candidate {
  constructor(
    public firstname: string = '',
    public lastname: string = '',
    public email: string = '',
    public phoneNumber: string = '',
    public profileURL: string = '',
    public companyId: string = '',
    public active: boolean = true,
    public deleted: boolean = false,
    public blocked: boolean = false,
    public rate: number | null = null,
    public mergedIntoCandidateId: string = '',
    public alternateEmails: string[] = []
  ) {}
}

export class CandidateId {
  constructor(
    public id: string = '',
    public firstname: string = '',
    public lastname: string = '',
    public email: string = '',
    public phoneNumber: string = '',
    public profileURL: string = '',
    public companyId: string = '',
    public active: boolean = true,
    public deleted: boolean = false,
    public blocked: boolean = false,
    public files: CandidateFile[] = [],
    public skills: {
      id: string;
      skillName: string;
      skillLevel: string;
    }[] = [],
    public addedOn: string = '',
    public rate: number | null = null,
    public mergedIntoCandidateId: string = '',
    public alternateEmails: string[] = []
  ) {}
}
export class CandidateFile {
  constructor(
    public createdDate: string = '',
    public createdBy: string = '',
    public id: string = '',
    public name: string = '',
    public contentType: string = ''
  ) {}
}

export interface PersonalInfoExtractionResponse {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
  country_code?: string;
  linkedin_url?: string;
  profile_url?: string;
}

export type ProfileUrlVerificationStatus =
  | 'VERIFIED'
  | 'REACHABLE'
  | 'RESTRICTED'
  | 'NOT_FOUND'
  | 'INVALID'
  | 'BLOCKED'
  | 'UNAVAILABLE';

export interface ProfileUrlVerification {
  url: string;
  status: ProfileUrlVerificationStatus;
  statusCode: number | null;
  message: string;
  acceptable: boolean;
}
